import { getIndicatorOpinionSupport } from "../../../../../../rest/indicator";
import { makeWorkbook } from "../../utils/excel";

const rowsFrom = (payload) =>
  Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.results)
    ? payload.results
    : Array.isArray(payload)
    ? payload
    : [];

export async function buildWorkbookOpinionIssuer() {
  const resp = await getIndicatorOpinionSupport();
  const payload = resp?.data || {};

  const rows = rowsFrom(payload).map((r) => ({
    description: r?.description ?? r?.issuer ?? r?.name ?? "-",
    assigned: Number(r?.assigned ?? r?.assignedCount ?? 0),
    counter: Number(r?.counter ?? r?.casesCount ?? 0),
    paymentCount: Number(r?.paymentCount ?? r?.payments ?? 0),
    value: Number(r?.value ?? r?.valueSum ?? r?.totalValue ?? 0),
    year: r?.year ?? null,
  }));

  rows.sort((a, b) => {
    const av = Number(a.value || 0);
    const bv = Number(b.value || 0);
    if (av === bv) {
      return String(a.description || "").localeCompare(
        String(b.description || ""),
        "pt-PT"
      );
    }
    return bv - av;
  });

  const totals = rows.reduce(
    (acc, r) => {
      acc.assigned += Number(r.assigned || 0);
      acc.counter += Number(r.counter || 0);
      acc.paymentCount += Number(r.paymentCount || 0);
      acc.value += Number(r.value || 0);
      return acc;
    },
    { assigned: 0, counter: 0, paymentCount: 0, value: 0 }
  );

  const numEntidades = rows.length;
  const taxaRealizacao =
    totals.assigned > 0
      ? Math.round((totals.counter / totals.assigned) * 100 * 10) / 10
      : 0;

  const detalheAoa = [
    [
      "Entidade Emissora de Parecer",
      "Pareceres Atribuídos",
      "Realizadas",
      "Pagamentos",
      "Valor",
    ],
    ...rows.map((r) => [
      r.description ?? "-",
      Number(r.assigned || 0),
      Number(r.counter || 0),
      Number(r.paymentCount || 0),
      Number(r.value || 0),
    ]),
  ];

  const resumoAoa = [
    ["Indicador", "Valor"],
    ["N.º de Entidades", numEntidades],
    ["Total Pareceres Atribuídos", totals.assigned],
    ["Total Realizadas", totals.counter],
    ["Total Pagamentos", totals.paymentCount],
    ["Total Valor", totals.value],
    ["Taxa de Realização (%)", taxaRealizacao],
  ];

  return makeWorkbook([
    { name: "Resumo", aoa: resumoAoa },
    { name: "Detalhe", aoa: detalheAoa },
  ]);
}
